import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-order-line-status',
  templateUrl: './order-line-status.component.html',
  styleUrls: ['./order-line-status.component.css']
})
export class OrderLineStatusComponent implements OnInit {
    public orderInternalNo: string;

    public itemsListStatuses: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.orderInternalNo = this.stateService.getStateParams()['order_internal_no'];
    }

    private async loadStatuses() {
        if (!!this.orderInternalNo) {
            this.itemsListStatuses = await this.datatask.Post(406, { order_internal_no: this.orderInternalNo });
        }
    }

    private async init() {
        this.loadStatuses();
    }

    ngOnInit() {
        this.init();
    }
}
